// Google Authentication Configuration
export const GOOGLE_AUTH_CONFIG = {
  // Replace this with your actual Google OAuth Client ID
  // You can get this from: https://console.cloud.google.com/apis/credentials
  CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || 'your-google-client-id.apps.googleusercontent.com',
  
  // Optional: Define scopes if needed
  SCOPES: [
    'openid',
    'email',
    'profile',
  ].join(' '),
};

// Add your Google Client ID to your .env file:
// VITE_GOOGLE_CLIENT_ID=your-actual-client-id.apps.googleusercontent.com
